module.exports = __webpack_public_path__ + "img/Truppführer_SB.df41bc41.svg";